<div class="align-items-center row h-100 to-left-1 {{(['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status) && !isDestination?'cursor-pointer':'')}}" (click)="$event.stopPropagation();  params.data.status !== 'DELETED' && !isDestination && routeToDetails()">
   <div >
      <span class="{{status}} status-bar"> {{status | titlecase}}</span>
   </div>
</div>
